<template>
  <client-only>
    <header class="detail-header">
      <div class="header-wrap">
        <div class="header-left cursor">
          <admin-side-logo @click="onClickHeaderItem('/admin')" />
        </div>
        <div class="header-item__wrap">
          <div class="header-item" @click="onClickHeaderItem('/admin/dashboard')">대시보드</div>
          <div class="header-item" @click="mainMenuDropDown = !mainMenuDropDown">
            메인메뉴 관리
            <ArrowDownIcon />
            <div v-if="mainMenuDropDown" class="menu-dropdown">
              <div v-for="(item, index) in mainMenuItems" :key="index" @click="onClickHeaderItem(item.path)">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="header-item" @click="onClickHeaderItem('/admin/member')">회원 관리</div>
          <div class="header-item" @click="onClickHeaderItem('/admin/management')">서비스, 회원사업, 세미나 신청 및 결제관리</div>
          <div class="header-item" @click="otherMenuDropDown = !otherMenuDropDown">
            기타 메뉴 관리
            <ArrowDownIcon />
            <div v-if="otherMenuDropDown" class="menu-dropdown">
              <div v-for="(item, index) in otherMenuItems" :key="index" @click="onClickHeaderItem(item.path)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="isAuthenticated" class="header-right">
          <div class="header-item" @click="onClickLogout">로그아웃</div>
          <shopping-cart-fill :notification="paymentNotification" @reload="getNotificationList('PAYMENT')" />
          <user-add-fill :notification="memberNotification" @reload="getNotificationList('MEMBER')" />
        </div>
      </div>
    </header>
  </client-only>
</template>
<script>
import {ref, onMounted} from 'vue'
import {useAdminCommonStore} from '~/store/admin-common/index.js'
import {useMemberStore} from '~/store/member/index.js'
import ShoppingCartFill from 'assets/svg/shopping-cart-fill.vue'
import UserAddFill from 'assets/svg/user-add-fill.vue'
import AdminSideLogo from 'assets/svg/admin-side-logo.vue'
import ArrowDownIcon from 'assets/svg/arrow-down-icon.vue'

export default {
  name: 'AdminHeader',
  components: {UserAddFill, ShoppingCartFill, ArrowDownIcon, AdminSideLogo},
  setup() {
    const adminCommonStore = useAdminCommonStore()
    const store = useMemberStore()
    const member = store.member
    const isAuthenticated = store.isAuthenticated
    const mainMenuDropDown = ref(false)
    const mainMenuItems = ref([
      {name: '메인페이지', path: '/admin/main'},
      {name: '회원사업', path: '/admin/membership-business?menu=0&subMenu=0&type='},
      {name: '공개강좌', path: '/admin/seminar?menu=0&subMenu=0'},
      {name: '월간인사관리', path: '/admin/magazine?menu=0&subMenu=0'},
      {name: 'KPI 도서', path: '/admin/kpi-book'},
      {name: 'HR 자료', path: '/admin/hr'}
    ])
    const otherMenuDropDown = ref(false)
    const otherMenuItems = ref([
      {name: '고객센터', path: '/admin/customer-service?menu=0'},
      {name: '회사정보', path: '/admin/greeting?menu=0'},
      {name: '인사뱅크', path: '/admin/insa?menu=0'},
      {name: '이용방침', path: '/admin/terms?menu=0'},
      {name: '인사말', path: '/admin/ceo'},
      {name: '광고 제휴 문의', path: '/admin/partnership?menu=0'}
    ])
    const paymentNotification = ref({
      count: 0,
      list: []
    })
    const memberNotification = ref({
      count: 0,
      list: []
    })
    let intervalId = null

    const getNotificationList = async type => {
      const {data} = await adminCommonStore.getNotificationList({type})
      if (type === 'PAYMENT') {
        paymentNotification.value = data
      } else {
        memberNotification.value = data
      }
    }

    onMounted(async () => {
      if (window.location.pathname.startsWith('/admin')) {
        // 60초마다 알림 갱신
        const TIME_OUT = 600000
        await getNotificationList('PAYMENT')
        await getNotificationList('MEMBER')
        intervalId = setInterval(async () => {
          await getNotificationList('PAYMENT')
          await getNotificationList('MEMBER')
        }, TIME_OUT)
      }
    })

    onUnmounted(() => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    })

    return {
      store,
      adminCommonStore,
      member,
      isAuthenticated,
      mainMenuItems,
      mainMenuDropDown,
      otherMenuItems,
      otherMenuDropDown,
      paymentNotification,
      memberNotification
    }
  },
  // 페이지 이동 시 드롭다운 다 False
  watch: {
    $route() {
      this.mainMenuDropDown = false
      this.otherMenuDropDown = false
    }
  },
  methods: {
    async getNotificationList(type) {
      const {data} = await this.adminCommonStore.getNotificationList({type})
      if (type === 'PAYMENT') {
        this.paymentNotification = data
      } else {
        this.memberNotification = data
      }
    },
    onClickHeaderItem(path) {
      this.$router.push(path)
    },
    onClickLogout() {
      if (confirm('로그아웃 하시겠습니까?')) {
        this.store.logout()
        window.location.reload()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.detail-header {
  border-bottom: 1px solid #f2f2f2;
  position: fixed;
  width: 100%;
  z-index: 2;
  background: #fff;
}

.header-item {
  font-family: 'Pretendard', sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;

  .menu-dropdown {
    position: absolute;
    top: 122%;
    left: 0;
    width: 120%;
    background: #fff;
    border: 1px solid #f2f2f2;
    z-index: 10;

    div {
      padding: 8px 16px;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;

      &:hover {
        background: #f2f2f2;
      }
    }
  }

  &.on {
    color: #0058aa;
  }

  &:hover {
    color: #0058aa;
  }
}

.header-wrap {
  height: 64px;
  width: calc(100% - 64px);
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;

  .header-left {
    display: flex;
    align-items: center;

    .header-logo {
      margin-right: 38px;
      cursor: pointer;
    }
  }

  .header-item__wrap {
    display: flex;
    gap: 24px;
    font-size: 16px;
    font-weight: 700;
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 30px;

    .header-item {
      font-family: 'Pretendard', sans-serif;
      font-size: 16px;
      font-weight: 400;
      cursor: pointer;
      color: #606060;

      &:hover {
        color: #0058aa;
      }
    }
  }
}
</style>
